module.exports = __webpack_public_path__ + "static/media/salmah-blue.d762214d.png";